import styled from 'styled-components';

export const StyledSettings = styled.div`
	padding-bottom: 24px;

	@media ${({ theme }) => theme.device.mobile} {
		padding: 24px 16px;
	}
`;

export const StyledSettingsTitle = styled.div`
  font-weight: bold;
  font-size: 1.2rem;
`;

export const StyledSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledSettingsSection = styled.div`
  display: flex;
`;
export const StyledSettingsTitleSection = styled.div`
  flex: 1;
`;
export const StyledSettingsConfigurationSection = styled.div`
  flex: 2;
  padding-left:10px;
`;

export const PageTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.18000000715255737px;

  margin: 0 0 20px 0;
`;